import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { ModalActionsStyled, ModalStyled } from '@nike/nike-design-system-components';
import { breakpoints, nike } from '@nike/nike-design-tokens';
const {
  podiumCdsButtonColorBgPrimaryHoverOnDark,
  podiumCdsButtonColorBgPrimaryHoverOnLight,
  podiumCdsColorTextPrimaryOnDark,
  podiumCdsColorTextPrimaryOnLight,
  podiumCdsIconButtonColorBgSecondary,
  podiumCdsSizeSpacingM,
} = nike;
import { desktopOnly, focusRingStyle } from '../../utils/sharedStyles';

const { podiumCdsBreakpointS } = breakpoints;
const buttonNcss4dot2StateMods = css`
  color: ${podiumCdsColorTextPrimaryOnDark};
  &:hover,
  &:active {
    background: ${podiumCdsButtonColorBgPrimaryHoverOnDark};
  }
`;

export const cookieModalDoneButton = 'cookie-modal-done-button';
export const CookieModalStyled = styled(ModalStyled)`
  button.${cookieModalDoneButton} {
    color: ${podiumCdsColorTextPrimaryOnDark};
    ${focusRingStyle}
  }
`;
export const CookieCheckboxContainer = styled.div`
  margin-block-end: 10px;

  .cookieCheckboxLabelSlot > * {
    padding-inline-start: 12px;
  }
`;

export const FooterSeparator = styled.hr`
  margin-block: 20px;
`;

export const backdropContainer = 'cookie-modal-backdrop-container';
export const ncss4Dot2textColorFix = 'ncss-4-dot-2-text-color-fix';

export const TwoButtonModalActions = styled(ModalActionsStyled)`
  @media (${desktopOnly}) {
    .${backdropContainer} > & {
      padding-left: 0;
    }
  }
  .cookie-modal-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: ${podiumCdsSizeSpacingM};

    button {
      margin: 0;
      // ncss 4.2 compatibility
      ${buttonNcss4dot2StateMods}
      ${focusRingStyle}
    }
    button.${ncss4Dot2textColorFix} {
      color: ${podiumCdsColorTextPrimaryOnLight};
      &:hover {
        border: ${podiumCdsButtonColorBgPrimaryHoverOnLight};
        background-color: ${podiumCdsIconButtonColorBgSecondary};
      }
    }

    @media (max-width: ${podiumCdsBreakpointS}) {
      grid-template-columns: 1fr;
    }
  }
`;

export const ThreeButtonModalActions = styled(TwoButtonModalActions)`
  .cookie-modal-actions {
    button {
      color: ${podiumCdsColorTextPrimaryOnDark};
      ${buttonNcss4dot2StateMods}
    }
    button.${ncss4Dot2textColorFix} {
      color: ${podiumCdsColorTextPrimaryOnLight};
    }
    // place the Reject button to the right
    @media (min-width: ${podiumCdsBreakpointS}) {
      button:last-of-type {
        grid-column: 2;
      }
    }
  }
`;
